import { render } from "./SettingsPublicProfiles.vue?vue&type=template&id=cd34caa8&ts=true"
import script from "./SettingsPublicProfiles.vue?vue&type=script&lang=ts"
export * from "./SettingsPublicProfiles.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__